export function unFixMasthead() {
    const fixedElement = document.querySelector('.site-masthead__slides');

    window.addEventListener('scroll', function() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const bodyHeight = document.body.offsetHeight;

    if (scrollPosition + windowHeight >= bodyHeight) {
        fixedElement.style.position = 'absolute';

    } else {
        fixedElement.style.position = 'fixed';

    }
    });
}